import React, { useState, useEffect, useCallback } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  DisablableOption, 
} from "@models";
import { 
  ARMOR_TYPE_OPTIONS, 
  CharacterOptions, 
  LANGUAGE_OPTIONS, 
  SENSE_OPTIONS, 
  SKILL_OPTIONS, 
  WEAPON_KEYWORD_OPTIONS
} from "@dndModels";
import { 
  CONSTANTIZED_DATA_TYPES,
  DONT_SORT_LIST, 
  FIELD_DISPLAY_MAP, 
  INT_CONSTANTS, 
  INT_DEFAULTS, 
  IS_SINGLE,
  NO_EXCLUDE, 
  USE_BOOLEAN, 
  USE_CONSTANT_LIST, 
  USE_FIELD_DATA_TYPE, 
  USE_ID, 
  USE_INT, 
  USE_STRING 
} from "@dndModels/DataTypeConstants";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import SelectObjectFieldBox from "@components/input/selects/SelectObjectFieldBox";

import CheckBox from "@components/input/CheckBox";
import SelectSourceBookBox from "@dndComponents/select/SelectSourceBookBox";
import { DataType, SourceBookType } from "@dndModels/Types";

interface Props {
  field: string;
  data_type?: DataType;
  quick: boolean;
  dont_use_api?: boolean;
  character_options?: CharacterOptions;
  the_filter: any;
  options_for_fields: { [field: string]: DisablableOption[] };
  log_it?: boolean;
  onChange: (filter: string[], exclude: boolean) => void;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function FilterField({ 
  field, 
  data_type,
  quick,
  dont_use_api,
  character_options,
  the_filter,
  options_for_fields,
  log_it = false,
  onChange,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [my_filter, setMyFilter] = useState<string[]>([]);
  const [my_exclude, setMyExclude] = useState(false);
  const [source_book_types, setSourceBookTypes] = useState<SourceBookType[]>([]);
  const [reload_time, setReloadTime] = useState(0);

  const load = useCallback(() => {
    if (log_it) {
      debugger;
    }
    if (dont_use_api) {
      const value = the_filter[field];
      if (value !== undefined) {
        if (USE_BOOLEAN.includes(field)) {
          setMyFilter(value ? ["True"] : ["False"]);
          setMyExclude(false);
        } else if (USE_INT.includes(field) || USE_STRING.includes(field)) {
          setMyFilter([`${value}`]);
          setMyExclude(false);
        } else if (value["$nin"] !== undefined) {
          setMyFilter(value["$nin"]);
          setMyExclude(true);
        } else {
          setMyFilter(value["$in"]);
          setMyExclude(false);
        }
      }
    } else {
      const value = api.filters[field];
      if (value !== undefined) {
        if (USE_BOOLEAN.includes(field)) {
          setMyFilter(value);
          setMyExclude(false);
        } else if (USE_INT.includes(field) || USE_STRING.includes(field)) {
          setMyFilter(value);
          setMyExclude(false);
        } else {
          const exc = api.excludes.includes(field);
          setMyFilter(value);
          setMyExclude(exc);
        }
      }
    }
    setReloadTime(common_util.get_time_number());
  }, [field, the_filter, dont_use_api, log_it]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      load();
    }
  }, [fetched, load]);

  const setFilter = (changed: string[]) => {
    setMyFilter(changed);
    if (!dont_use_api) {
      api.set_filter(field, changed);
    }
    onChange(changed, my_exclude);
  }

  const setExclude = (changed: boolean) => {
    setMyExclude(changed);
    if (!dont_use_api) {
      api.set_exclude(field, changed);
    }
    onChange(my_filter, changed);
  }

  // let return_me: any = null;
  // if (field === "min_cr") {
  //   debugger;
  // }
  let values = my_filter;
  if (!values) {
    values = [];
  }
  const renderControl = () => {
    const options_for_field = options_for_fields[field];
    if (log_it) {
      debugger;
    }
    if (options_for_field) {
      if (field === "source_book") {
        // debugger;
        return (
          <SelectSourceBookBox
            multiple
            types={source_book_types}
            ids={values}
            options={options_for_field}
            onChangeMultiple={(types: SourceBookType[], ids: string[]) => {
              setSourceBookTypes(types);
              setFilter(ids);
            }}
          />
        );
      } else {
        return (
          <SelectStringBox
            name={ FIELD_DISPLAY_MAP[field] }
            options={options_for_field}
            values={ values } 
            multiple
            reload_time={reload_time}
            auto_sort={!DONT_SORT_LIST.includes(field)}
            // log_it={field === "tags"}
            onChange={setFilter}
          />
        );
      }
    } else if (USE_ID.includes(field)) {
      if (CONSTANTIZED_DATA_TYPES.includes(field)) {
        let options: DisablableOption[] = [];
        // debugger;
        switch (field) {
          case "armor_type": options = ARMOR_TYPE_OPTIONS; break;
          case "language": options = LANGUAGE_OPTIONS; break;
          case "sense": options = SENSE_OPTIONS; break;
          case "skill": options = SKILL_OPTIONS; break;
          case "weapon_keyword": options = WEAPON_KEYWORD_OPTIONS; break;
        }
        return (
          <SelectStringBox
            name={ FIELD_DISPLAY_MAP[field] }
            options={options}
            values={ values } 
            multiple
            auto_sort={!DONT_SORT_LIST.includes(field)}
            onChange={setFilter}
          />
        );
      } else {
        const new_filter: any = { };
        if (character_options) {
          if (data_type === "source_book") {
            if (!new_filter._id) {
              new_filter._id = { "$in": character_options.source_books };
            }
          } else {
            if (!new_filter.source_books) {
              new_filter.source_books = {};
              new_filter.source_books.id = { "$in": character_options.source_books };
            }
            if (!new_filter._id) {
              if (data_type === "race") {
                if (character_options.blocked && character_options.blocked.length > 0) {
                  new_filter._id = { "$nin": character_options.blocked };
                }
              } else if (data_type === "game_class") {
                if (character_options.blocked.length > 0) {
                  new_filter._id = { "$nin": character_options.blocked };
                }
              } else if (data_type === "subclass") {
                if (character_options.blocked.length > 0) {
                  new_filter._id = { "$nin": character_options.blocked };
                }
              } else if (data_type === "gift") {
                if (character_options.blocked.length > 0) {
                  new_filter._id = { "$nin": character_options.blocked };
                }
              }
            }
          }
        }
        if (field === "source_book") {
          return (
            <SelectSourceBookBox
              multiple
              types={source_book_types}
              ids={values}
              onChangeMultiple={(types: SourceBookType[], ids: string[]) => {
                setSourceBookTypes(types);
                setFilter(ids);
              }}
            />
          );
        } else {
          new_filter.is_dominant = true;
          // if (field === "spell_list") {
          //   debugger;
          // }
          return (
            <SelectObjectBox
              name={ FIELD_DISPLAY_MAP[field] }
              filter={new_filter}
              values={ values } 
              multiple
              data_type={ field as DataType }
              auto_sort={!DONT_SORT_LIST.includes(field)}
              use_field="variant_group_id"
              onChange={setFilter}
            />
          );
        }
      }
    } else if (USE_BOOLEAN.includes(field)) {
      if (log_it) {
        console.log(field);
        console.log(values);
      }
      return (
        <SelectStringBox
          name={ FIELD_DISPLAY_MAP[field] }
          options={["Any","True","False"]}
          value={ values.length === 0 ? "Any" : values[0] } 
          auto_sort={!DONT_SORT_LIST.includes(field)}
          reload_time={reload_time}
          onChange={(changed: string) => {
            if (changed === "Any") {
              setFilter([]);
            } else {
              setFilter([changed]);
            }
          }}
        />
      );
    } else if (USE_INT.includes(field)) {
      if (log_it) {
        debugger;
        console.log(field);
        console.log(values);
      }
      return (
        <SelectStringBox
          name={ FIELD_DISPLAY_MAP[field] }
          options={INT_CONSTANTS[field]}
          value={ values.length === 0 ? `${INT_DEFAULTS[field]}` : values[0] } 
          // auto_sort
          reload_time={reload_time}
          onChange={setFilter}
        />
      );
    } else if (USE_STRING.includes(field)) {
      if (log_it) {
        console.log(field);
        console.log(values);
      }
      return (
        <StringBox
          name={ FIELD_DISPLAY_MAP[field] }
          value={ values.length === 0 ? "" : values[0] } 
          onBlur={(changed: string) => {
            if (changed === "") {
              setFilter([]);
            } else {
              setFilter([changed]);
            }
          }}
        />
      );
    } else {
      const constant_list = USE_CONSTANT_LIST[field];
      if (constant_list) {
        // if (field === "feat_tier") {
        //   console.log(values);
        // }
        if (IS_SINGLE.includes(field)) {
          return (
            <SelectStringBox
              name={ FIELD_DISPLAY_MAP[field] }
              value={ values.length === 0 ? "Any" : values[0] } 
              options={ constant_list }
              extra_options={["Any"]}
              // log_it={field === "feature_source_type"}
              auto_sort={!DONT_SORT_LIST.includes(field)}
              reload_time={reload_time}
              onChange={(changed: string) => {
                if (changed === "Any") {
                  setFilter([]);
                } else {
                  setFilter([changed]);
                }
              }}
            />
          );
        } else {
          return (
            <SelectStringBox
              name={ FIELD_DISPLAY_MAP[field] }
              values={ values } 
              multiple
              options={ constant_list }
              // log_it={field === "feat_tier"}
              auto_sort={!DONT_SORT_LIST.includes(field)}
              reload_time={reload_time}
              onChange={setFilter}
            />
          );
        }
      } else {
        const field_data_type = USE_FIELD_DATA_TYPE[field];
        if (field_data_type) {
          if (CONSTANTIZED_DATA_TYPES.includes(field_data_type)) {
            console.error("Not Implemented");
          } else {
            if (IS_SINGLE.includes(field)) {
              return (
                <SelectObjectFieldBox
                  name={ FIELD_DISPLAY_MAP[field] }
                  value={ values.length === 0 ? "Any" : values[0] } 
                  data_type={ field_data_type }
                  extra_options={["Any"]}
                  field={ field }
                  onChange={(changed: string) => {
                    if (changed === "Any") {
                      setFilter([]);
                    } else {
                      setFilter([changed]);
                    }
                  }}
                />
              );
            } else {
              return (
                <SelectObjectFieldBox
                  name={ FIELD_DISPLAY_MAP[field] }
                  values={ values } 
                  multiple
                  data_type={ field_data_type }
                  field={ field }
                  onChange={setFilter}
                />
              );
            }
          }
        } else if (data_type) {
          if (CONSTANTIZED_DATA_TYPES.includes(field_data_type)) {
            console.error("Not Implemented");
          } else {
            if (IS_SINGLE.includes(field)) {
              return (
                <SelectObjectFieldBox
                  name={ FIELD_DISPLAY_MAP[field] }
                  value={ values.length === 0 ? "Any" : values[0] } 
                  data_type={ data_type }
                  extra_options={["Any"]}
                  field={ field }
                  onChange={(changed: string) => {
                    if (changed === "Any") {
                      setFilter([]);
                    } else {
                      setFilter([changed]);
                    }
                  }}
                />
              );
            } else {
              return (
                <SelectObjectFieldBox
                  name={ FIELD_DISPLAY_MAP[field] }
                  values={ values } 
                  data_type={ data_type }
                  field={ field }
                  onChange={setFilter}
                />
              );
            }
          }
        }
      }
    }
  }

  if (log_it) {
    console.log(field);
    console.log(FIELD_DISPLAY_MAP);
    console.log(FIELD_DISPLAY_MAP[field]);
    // console.log(return_me);
    // debugger;
  }
  const xs = (values.length === 0 && !USE_STRING.includes(field)) || USE_BOOLEAN.includes(field) || USE_INT.includes(field) || NO_EXCLUDE.includes(field) ? 12 : 9;
  const exclude = values.length > 0 && !USE_BOOLEAN.includes(field) && !USE_INT.includes(field) && !NO_EXCLUDE.includes(field);
  const empty = values.length === 0 && USE_STRING.includes(field);
  if (quick) {
    return (
      <Grid
        size={{
          xs: xs
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            { renderControl() }
          </Grid>
          { exclude &&
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox
                name="Exclude"
                value={my_exclude}
                onChange={setExclude}
              />
            </Grid>
          }
          { empty &&
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox
                name="Empty"
                value={my_exclude}
                onChange={setExclude}
              />
            </Grid>
          }
        </Grid>
      </Grid>
    );
  } else {
    return (
      <>
        <Grid
          size={{
            xs: xs
          }}>
          { renderControl() }
        </Grid>
        { exclude &&
          <Grid
            size={{
              xs: 3
            }}>
            <CheckBox
              name="Exclude"
              value={my_exclude}
              onChange={setExclude}
            />
          </Grid>
        }
        { empty &&
          <Grid
            size={{
              xs: 3
            }}>
            <CheckBox
              name="Empty"
              value={my_exclude}
              onChange={setExclude}
            />
          </Grid>
        }
      </>
    );
  }
}
